import { Controller } from "@hotwired/stimulus"

// Click on the avatar stack opens the side panel for the task so the
// assignee can be changed via the panel's assignee select. Polish pass
// can replace this with an inline popover picker.
export default class extends Controller {
  static values = { taskId: String }

  openPicker(event) {
    event.stopPropagation()
    const row = this.element.closest("[data-controller~='intern-task-row']")
    if (row) row.dispatchEvent(new Event("click", { bubbles: true }))
  }
}
